/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { useMutation } from '@apollo/client';
import { notifications } from '@mantine/notifications';
import { useParams } from 'react-router-dom';

import {
  DedicatedEndpointRestartDocument,
  DedicatedEndpointStatusDocument,
  DedicatedEndpointStatusWithPhaseDocument,
} from '@fai/friendli-suite/generated/client/graphql';
import { errorProps } from '@fai/ui/components/notification/props';

export const useRestartEndpoint = (_endpointId?: string) => {
  const { teamId = '', projectId = '', endpointId: endpointIdParam } = useParams();

  const endpointId = _endpointId ?? endpointIdParam ?? '';

  const [restartEndpointMutation, { loading }] = useMutation(DedicatedEndpointRestartDocument, {
    refetchQueries: [
      {
        query: DedicatedEndpointStatusDocument,
        variables: { endpointId },
      },
      {
        query: DedicatedEndpointStatusWithPhaseDocument,
        variables: { endpointId },
      },
    ],
    onCompleted: (response) => {
      switch (response.dedicatedEndpointRestart.__typename) {
        case 'UserPermissionError':
        case 'TeamNotExistError': {
          notifications.show({
            ...errorProps,
            message: response.dedicatedEndpointRestart.message,
          });

          break;
        }
      }
    },
  });

  const restartEndpoint = () => {
    restartEndpointMutation({
      variables: { input: { teamId, projectId, endpointId } },
    });
  };

  return { restartEndpoint, loading };
};
